import { default as Sections } from './sections';

export { Sections as HomepageSections };
